// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Container = require("../common/Components/Container.bs.js");
let HtmlHolder = require("../common/Components/HtmlHolder.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");

function SharedMessageCard(props) {
  let __hideIfEmpty = props.hideIfEmpty;
  let agentInfo = props.agentInfo;
  let message = props.message;
  let subject = props.subject;
  let hideIfEmpty = __hideIfEmpty !== undefined ? __hideIfEmpty : true;
  if (hideIfEmpty && subject === undefined && message === undefined && agentInfo === undefined) {
    return null;
  }
  return JsxRuntime.jsx(Container.make, {
    children: JsxRuntime.jsxs("div", {
      children: [
        subject !== undefined ? JsxRuntime.jsx("h2", {
            children: subject,
            className: "text-gray-700 font-medium text-3xl"
          }) : null,
        message !== undefined ? JsxRuntime.jsx(HtmlHolder.make, {
            innerHtml: message
          }) : null,
        Stdlib_Option.getOr(agentInfo, null)
      ],
      className: "bg-white p-5 flex flex-col gap-6 border rounded"
    })
  });
}

let make = SharedMessageCard;

exports.make = make;
/* Container Not a pure module */
